import { fetchAuthSession } from "aws-amplify/auth";

export class AuthenticationSessionError extends Error {
  readonly cause?: unknown;

  constructor(cause?: unknown) {
    super("Authentication session is unavailable");
    this.name = "AuthenticationSessionError";
    this.cause = cause;
  }
}

export async function getAccessToken() {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken;

    if (!token) {
      throw new AuthenticationSessionError();
    }

    return token.toString();
  } catch (error) {
    if (error instanceof AuthenticationSessionError) {
      throw error;
    }

    throw new AuthenticationSessionError(error);
  }
}
